import { jsx as _jsx } from "react/jsx-runtime";
import IconsSvg from "public/icons.svg";
const Icon = (props) => {
    const size = props.size || 20;
    const href = `${IconsSvg}#` + props.name;
    return (_jsx("svg", { width: size, height: size, className: props.className, onClick: props.onClick, children: _jsx("use", { href: href }) }));
};
export default Icon;
